import React from 'react'
import Paper from '@mui/material/Paper'
import { TextBlock } from '../../../../components/1elements'

const CircleEdit = ({ shape, setShape }) => {
  const changeRelay = e => {
    if (!e.target.value && e.target.name !== 'name') {
      e.defaultPrevented = true
      e.isDefaultPrevented = true
      return
    }
    const nameParts = e.target.name.split('.')
    if (nameParts.length > 1) {
      const center = shape.center
      center[nameParts[1]] = Number(e.target.value)
      setShape({ id: shape.id, center }, true)
    } else {
      if (e.target.name === 'name') {
        setShape({ id: shape.id, [e.target.name]: e.target.value }, false)
      } else {
        setShape(
          { id: shape.id, [e.target.name]: Number(e.target.value) },
          true
        )
      }
    }
  }
  return (
    <Paper>
      <TextBlock heading={shape.name + ':'}>
        <div> Name:</div>
        <input
          type='text'
          name='name'
          value={shape.name}
          onChange={changeRelay}
          required
          maxLength={150}
          style={{ width: '100%' }}
        />
        <div>Center Lat:</div>
        <input
          type='number'
          name='center.lat'
          value={shape.center.lat}
          onChange={changeRelay}
          max={90}
          min={-90}
          required
          step={0.01}
          style={{ width: '100%' }}
        />
        <div> Center Lng:</div>
        <input
          type='number'
          name='center.lng'
          value={shape.center.lng}
          onChange={changeRelay}
          max={180}
          min={-180}
          required
          step={0.01}
          style={{ width: '100%' }}
        />
        <div>Radius:</div>
        <input
          type='number'
          name='radius'
          value={shape.radius}
          onChange={changeRelay}
          required
          max={131233595}
          step={1}
          style={{ width: '100%' }}
        />
      </TextBlock>
    </Paper>
  )
}

export default React.memo(CircleEdit)
